<ion-icon [style.color]="color" name="lock-closed"></ion-icon>

<div class="popup-message">
  <h3 [style.color]="color">
    {{ message }}
  </h3>
</div>

<div class="popup-footer" [style.backgroundColor]="color">
  <ion-button
    expand="full"
    size="large"
    strong="true"
    fill="clear"
    (click)="validated.emit(true)"
  >
    {{ buttonLabel }}
  </ion-button>
</div>
